export class AlertMessage {
  type: string;
  message: string;
  code: string;

  constructor(type: string, message: string) {
    this.type = type;
    this.message = message;
  }
}

export enum MessagePosition {
  Top,
  RegalienneSection,
  SectorielleSection,
  SectorielleSectionAjoutStructure,
  CorrespondanceSection,
  PiecesJustificativesSection,
  RechercheEtablissementSection,
  ListProlSection,
  ListDemandSection
}
